/* Zolo PDP behavior — vanilla JS, no dependencies.
   State lives in the main section; sticky bar syncs via zpdp:state events.
   Several sections include this same file, so guard against multiple
   executions (each <script src> tag runs the file again) and re-inits. */
(function () {
  'use strict';
  if (window.__zpdpJSLoaded) return;
  window.__zpdpJSLoaded = true;

  function once(root) {
    if (root.dataset.zpdpInit) return false;
    root.dataset.zpdpInit = '1';
    return true;
  }

  function formatMoney(cents, prefix) {
    return prefix + ' ' + (cents / 100).toFixed(2);
  }

  /* ------------------------------ main section ------------------------------ */
  function initMain(root) {
    if (!once(root)) return;
    var dataEl = root.querySelector('[data-zpdp-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var prefix = root.dataset.currencyPrefix || 'AED';
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var priceEl = root.querySelector('[data-zpdp-price]');
    var compareEl = root.querySelector('[data-zpdp-compare]');
    var saveEl = root.querySelector('[data-zpdp-save]');
    var atcBtn = form.querySelector('[data-zpdp-atc]');
    var showByMediaId = null;
    var requireChoice = root.dataset.requireChoice === 'true';

    function chosen() {
      return !requireChoice || !!root.querySelector('input[name="zpdp-option"]:checked');
    }
    function currentVariant() {
      var checked = root.querySelector('input[name="zpdp-option"]:checked');
      var id = checked ? Number(checked.value) : Number(idInput.value);
      return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
    }
    function planActive() {
      var checked = root.querySelector('input[name="zpdp-plan"]:checked');
      return checked && checked.value !== '' ? checked.value : null;
    }

    function render() {
      var v = currentVariant();
      var plan = planActive();
      var price = v.price;
      var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;
      if (plan && v.plan_price) {
        price = v.plan_price;
        compare = v.price;
      }
      idInput.value = chosen() ? v.id : '';
      if (planInput) planInput.value = plan && v.plan_id ? v.plan_id : '';
      if (priceEl) priceEl.textContent = formatMoney(price, prefix);
      if (compareEl) {
        if (compare) {
          compareEl.textContent = formatMoney(compare, prefix);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (compare) {
          var saved = compare - price;
          var amount = saved % 100 === 0 ? prefix + ' ' + saved / 100 : formatMoney(saved, prefix);
          saveEl.textContent = (saveEl.dataset.label || 'Save') + ' ' + amount + ' (' + Math.round(saved / compare * 100) + '%)';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      if (atcBtn) {
        if (!chosen()) {
          atcBtn.disabled = true;
          atcBtn.textContent = atcBtn.dataset.labelChoose || atcBtn.dataset.labelAdd;
        } else {
          atcBtn.disabled = !v.available;
          atcBtn.textContent = v.available ? atcBtn.dataset.labelAdd : atcBtn.dataset.labelSoldout;
        }
      }
      document.dispatchEvent(new CustomEvent('zpdp:state', {
        detail: { variant: v, plan: !!plan, price: price, compare: compare, prefix: prefix }
      }));
    }

    root.querySelectorAll('input[name="zpdp-option"]').forEach(function (input) {
      input.addEventListener('change', function () {
        render();
        var v = currentVariant();
        if (v.media_id && showByMediaId) showByMediaId(v.media_id);
      });
    });
    root.querySelectorAll('input[name="zpdp-plan"]').forEach(function (input) {
      input.addEventListener('change', function () { render(); });
    });
    document.addEventListener('zpdp:set-plan', function (e) {
      var target = root.querySelector('input[name="zpdp-plan"][value="' + (e.detail.plan ? 'subscribe' : '') + '"]');
      if (target && !target.checked) {
        target.checked = true;
        render();
      }
    });
    function scrollToVariants() {
      var vp = root.querySelector('.zpdp-variants');
      if (vp) vp.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    form.addEventListener('submit', function (e) {
      if (!chosen()) {
        e.preventDefault();
        scrollToVariants();
      }
    });
    document.addEventListener('zpdp:submit', function () {
      if (!chosen()) {
        scrollToVariants();
        return;
      }
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });

    /* qty stepper */
    var qtyInput = root.querySelector('[data-zpdp-qty]');
    root.querySelectorAll('[data-zpdp-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Number(qtyInput.value || 1) + Number(btn.dataset.zpdpQtyChange);
        qtyInput.value = Math.max(1, next);
      });
    });

    /* gallery — stage items and thumbs mirror product media 1:1; item i is shown by
       thumb i, the arrows, or a variant's featured media. Videos play (muted) when
       shown and pause when hidden. */
    var stage = root.querySelector('[data-zpdp-gallery-main]');
    var items = stage ? Array.prototype.slice.call(stage.querySelectorAll('[data-zpdp-gallery-item]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-zpdp-thumb]'));
    if (items.length) {
      var galleryIdx = 0;
      function playVideo(item, on) {
        var v = item.querySelector('video');
        if (!v) return;
        if (on) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      }
      function showMedia(i) {
        galleryIdx = (i + items.length) % items.length;
        items.forEach(function (item, ii) {
          var on = ii === galleryIdx;
          item.classList.toggle('is-active', on);
          playVideo(item, on);
        });
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === galleryIdx); });
      }
      thumbs.forEach(function (thumb, ti) {
        thumb.addEventListener('click', function () { showMedia(ti); });
      });
      var mediaIds = items.map(function (it) { return it.dataset.mediaId || ''; });
      showByMediaId = function (id) {
        var i = mediaIds.indexOf(String(id));
        if (i > -1) showMedia(i);
      };
      var prevBtn = root.querySelector('[data-zpdp-gallery-prev]');
      var nextBtn = root.querySelector('[data-zpdp-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { showMedia(galleryIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showMedia(galleryIdx + 1); });
      playVideo(items[0], true);
    }

    /* expose ATC visibility for the sticky bar */
    if (atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        document.dispatchEvent(new CustomEvent('zpdp:atc-visible', { detail: { visible: entries[0].isIntersecting } }));
      }, { rootMargin: '0px 0px -60px 0px' }).observe(atcBtn);
    }

    render();
  }

  /* ------------------------------ testimonials ------------------------------ */
  function initReviews(root) {
    if (!once(root)) return;
    var jm = root.querySelector('[data-zpdp-jm]');
    if (jm) { initJudgeMeReviews(root, jm); return; }
    var track = root.querySelector('[data-zpdp-track]');
    var dotsWrap = root.querySelector('[data-zpdp-dots]');
    if (!track || !dotsWrap) return;
    var cards = track.children;
    if (!cards.length) return;
    dotsWrap.innerHTML = '';
    var dots = [];
    for (var i = 0; i < cards.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'zpdp-reviews__dot';
      dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
      (function (index) {
        dot.addEventListener('click', function () {
          cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      })(i);
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
    function update() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var active = 0;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (c.offsetLeft <= mid && c.offsetLeft + c.offsetWidth >= mid) { active = i; break; }
        if (c.offsetLeft + c.offsetWidth / 2 <= mid) active = i;
      }
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === active);
        d.classList.toggle('is-near', Math.abs(i - active) === 1);
      });
    }
    function step(dir) {
      var card = cards[0];
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24;
      var by = (card ? card.offsetWidth : 340) + gap;
      track.scrollBy({ left: dir * by, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-zpdp-rev-prev]');
    var next = root.querySelector('[data-zpdp-rev-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function updateNav() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
      var idle = track.scrollWidth <= track.clientWidth + 1;
      if (prev) prev.hidden = idle;
      if (next) next.hidden = idle;
    }

    track.addEventListener('scroll', function () {
      requestAnimationFrame(function () { update(); updateNav(); });
    }, { passive: true });
    window.addEventListener('resize', updateNav);
    update();
    updateNav();
  }

  /* Judge.me product widget dressed as the card scroller: arrows scroll its
     review list, and reviews whose text is only the product name (star-only
     replies to the review email) are shown as rating cards. The list is
     re-rendered by Judge.me on paging/sorting, so nothing is cached. */
  function initJudgeMeReviews(root, wrap) {
    var prev = root.querySelector('[data-zpdp-rev-prev]');
    var next = root.querySelector('[data-zpdp-rev-next]');
    var pending = null;
    function track() { return wrap.querySelector('.jdgm-rev-widg__reviews'); }
    function atStart(t) { return t.scrollLeft <= 0; }
    function atEnd(t) { return t.scrollLeft >= t.scrollWidth - t.clientWidth - 1; }
    function pageLink(delta) {
      var cur = wrap.querySelector('.jdgm-paginate__page.jdgm-curt');
      if (!cur) return null;
      var n = parseInt(cur.getAttribute('data-page'), 10) + delta;
      return n > 0 ? wrap.querySelector('.jdgm-paginate__page[data-page="' + n + '"]') : null;
    }
    function step(dir) {
      var t = track();
      if (!t) return;
      var link = dir > 0 && atEnd(t) ? pageLink(1) : (dir < 0 && atStart(t) ? pageLink(-1) : null);
      if (link) { pending = dir > 0 ? 'start' : 'end'; link.click(); return; }
      var card = t.querySelector('.jdgm-rev');
      var gap = parseFloat(getComputedStyle(t).columnGap || getComputedStyle(t).gap) || 24;
      t.scrollBy({ left: dir * ((card ? card.offsetWidth : 340) + gap), behavior: 'smooth' });
    }
    function updateNav() {
      var t = track();
      var fits = !t || t.scrollWidth <= t.clientWidth + 1;
      var more = !!pageLink(1), less = !!pageLink(-1);
      var idle = fits && !more && !less;
      if (prev) { prev.hidden = idle; prev.disabled = !idle && (!t || (atStart(t) && !less)); }
      if (next) { next.hidden = idle; next.disabled = !idle && (!t || (atEnd(t) && !more)); }
    }
    function tag() {
      wrap.querySelectorAll('.jdgm-rev').forEach(function (rev) {
        var body = rev.querySelector('.jdgm-rev__body');
        var title = (rev.getAttribute('data-product-title') || '').replace(/\s+/g, ' ').trim().toLowerCase();
        var text = body ? body.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
        rev.classList.toggle('zpdp-rev--rating-only', !!text && text === title);
      });
    }
    function settle() {
      tag();
      var t = track();
      if (t && pending && t.querySelector('.jdgm-rev')) {
        t.scrollLeft = pending === 'end' ? t.scrollWidth : 0;
        pending = null;
      }
      updateNav();
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    wrap.addEventListener('scroll', function () { requestAnimationFrame(updateNav); }, true);
    window.addEventListener('resize', updateNav);
    if (window.MutationObserver) {
      new MutationObserver(settle).observe(wrap, { childList: true, subtree: true });
    }
    settle();
    setTimeout(settle, 1500);
  }

  /* ---------------------------------- faq ----------------------------------- */
  function initFaq(root) {
    if (!once(root)) return;
    root.querySelectorAll('.zpdp-faq-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var open = card.classList.contains('is-open');
        root.querySelectorAll('.zpdp-faq-card').forEach(function (c) {
          c.classList.remove('is-open');
          c.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          card.classList.add('is-open');
          card.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* -------------------------------- sticky bar ------------------------------ */
  function initSticky(root) {
    if (!once(root)) return;
    var priceEl = root.querySelector('[data-zpdp-sticky-price]');
    var compareEl = root.querySelector('[data-zpdp-sticky-compare]');
    var planBtn = root.querySelector('[data-zpdp-sticky-plan]');
    var planOn = false;
    var atcInView = true;

    function refreshVisibility() {
      root.classList.toggle('is-visible', !atcInView);
    }
    document.addEventListener('zpdp:atc-visible', function (e) {
      atcInView = e.detail.visible;
      refreshVisibility();
    });
    document.addEventListener('zpdp:state', function (e) {
      var d = e.detail;
      planOn = d.plan;
      if (priceEl) priceEl.textContent = formatMoney(d.price, d.prefix);
      if (compareEl) {
        if (d.compare) {
          compareEl.textContent = formatMoney(d.compare, d.prefix);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (planBtn) planBtn.classList.toggle('is-on', planOn);
    });
    if (planBtn) {
      planBtn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('zpdp:set-plan', { detail: { plan: !planOn } }));
      });
    }
    var atc = root.querySelector('[data-zpdp-sticky-atc]');
    if (atc) {
      atc.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('zpdp:submit'));
      });
    }
  }

  /* ---------------------------- feature carousel ---------------------------- */
  /* On phones the three feature sections become one swipeable row (1.25 cards
     visible), per the mobile design. Skipped in the theme editor so sections
     stay individually selectable there. */
  function initFeatureCarousel() {
    if (window.__zpdpFeatSlider) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!window.matchMedia('(max-width: 899px)').matches) return;
    var sections = Array.prototype.slice.call(document.querySelectorAll('.zpdp-feature'));
    if (sections.length < 2) return;
    window.__zpdpFeatSlider = true;
    var first = sections[0];
    var host = first.querySelector('.zpdp-container') || first;
    var row = document.createElement('div');
    row.className = 'zpdp-feature-scroller';
    sections.forEach(function (sec) {
      var card = sec.querySelector('.zpdp-feature__card');
      if (card) row.appendChild(card);
      if (sec !== first) sec.style.display = 'none';
    });
    host.appendChild(row);
  }

  /* --------------------------------- boot ----------------------------------- */
  function boot() {
    document.querySelectorAll('[data-zpdp-main]').forEach(initMain);
    document.querySelectorAll('[data-zpdp-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-zpdp-faq]').forEach(initFaq);
    document.querySelectorAll('[data-zpdp-sticky]').forEach(initSticky);
    initFeatureCarousel();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
